<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="form-row mb-4">
          <div class="col-md-6">
            <label for="pr_number">PR Number</label>
            <input class="form-control" type="text" v-model="pr_number" id="pr_number" readonly>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-sm table-hover table-bordered text-center" id="product_inbound_list">
            <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Unit</th>
              <th>PR Quantity</th>
              <th style="color: red">Remaining Inbounded</th>
              <th>Inbounded</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(pr_item, index) in pr_items" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ pr_item.product_name }}</td>
              <td>{{ pr_item.product_unit }}</td>
              <td>{{ pr_item.pr_quantity }}</td>
              <td style="color: red">{{ remainingInbounded(pr_item.pr_quantity, pr_item.total_inbounded) }}</td>
              <td>{{ pr_item.total_inbounded }}</td>
              <td>
                <a  class="btn btn-sm btn-info" href="javascript: void(0);" @click.prevent="productInboundDetail(pr_number, pr_item.product_id), $bvModal.show('partial-product-inbound-view-modal')"><i class="fa fa-info-circle mr-2"></i>Details</a>
              </td>
            </tr>
            </tbody>
          </table>
          <a-skeleton active :loading="loading"></a-skeleton>
          <h5 class="text-center text-secondary" v-if="pr_items.length === 0 && !flag">
            <Empty :image="simpleImage"></Empty>
          </h5>
        </div>
      </div>
    </div>
    <product-inbound-partial-view
      :product_inbounds="product_inbounds">
    </product-inbound-partial-view>
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue'
import apiClient from '@/services/axios'
import moment from 'moment'
import productInboundPartialView from '@/views/productInbound/modal/productInboundPartialView'

export default {
  name: 'List',
  components: { Empty, productInboundPartialView },
  data() {
    return {
      pr_items: {},
      product_inbounds: [],
      purchase_request_inbounds: [],
      product_id_array: {},
      pr_number: '',
      entry_date: '',
      loading: false,
      submitLoading: false,
      flag: false,
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
    }
  },
  mounted() {
    this.entryDateFormat()
    this.getPurchaseRequestDetail()
  },
  methods: {
    getPurchaseRequestDetail() {
      this.loading = true
      this.flag = true
      const purchaseRequestId = this.$route.params.purchase_request_id
      apiClient.get('api/product-inbound/detail/' + purchaseRequestId)
        .then(response => {
          this.loading = false
          this.flag = false
          this.pr_items = response.data.pr_items
          this.product_id_array = response.data.product_id_array
          this.pr_number = response.data.pr_number
          this.purchase_request_inbounds = response.data.purchase_request_inbounds
        })
        .catch(error => {
          console.log(error)
          this.btnLoading = false
        })
    },
    entryDateFormat() {
      this.entry_date = moment().format('YYYY-MM-DD')
      return moment().format('YYYY-MM-DD')
    },
    remainingInbounded(prQuantity, totalInbounded) {
      return parseFloat(prQuantity || 0) - parseFloat(totalInbounded || 0)
    },
    productInboundDetail(prNumber, productId) {
      this.product_inbounds = []
      const productInbounds = this.purchase_request_inbounds.filter(function (el) {
        return el.product_id === productId
      })
      this.product_inbounds = productInbounds
    },
  },
}
</script>

<style scoped>
.form-control-sm {
  height: calc(1.7em + .5rem + 2px) !important;
}
</style>
